// extracted by mini-css-extract-plugin
export var growableInput = "_8b-0";
export var tagContainer = "_8b-2";
export var textInput = "_8b-1";